import React, { PureComponent } from "react";
import { Col, Icon } from "antd";
import PropTypes from "prop-types";

import Viewer from "react-viewer";
import "react-viewer/dist/index.css";
import axios from "axios";
import BestButton from "./BestBtn";
import CheckboxButton from "./Checkbox";
import Tags from "./Tags";
import { roles } from "../../configs/constants";
import { Link } from "react-router-dom";
import { AWS_URL } from "../../configs/config";
const get = (path, object, defaultValue = null) =>
  path.reduce((xs, x) => (xs && xs.hasOwnProperty(x) ? xs[x] : defaultValue), object);
// const categories = require("./categories.json");
const MEDIA_DOWNLOAD_URL = process.env.REACT_APP_API + "/api/media/download/";

function forceDownload(url, fileName) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function() {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
}

class Photo extends React.Component {
  constructor(props) {
    super(props);
    let { media } = this.props;
    media = media || {};

    this.state = {
      media_id: media._id,
      visible: false,
      isTooltipBrandsVisible: false,
      isTooltipProductsVisible: false,
      isModalOfSelectionVisible: false,
      categories: [],
      isModalLoading: true,
      selectedBrands: media.brands,
      selectedProducts: media.products,
      isBefore: media.before || false,
      isAfter: media.after || false
    };
  }
  componentDidUpdate(prevProps) {
    const prevMedia = prevProps.media || {};
    const prevProducts = prevMedia.products || [];
    const prevBrands = prevMedia.brands || [];
    const media = this.props.media || {};
    const products = media.products || [];
    const brands = media.brands || [];

    if (prevMedia._id !== media._id || products.length !== prevProducts.length || brands.length !== prevBrands.length) {
      this.setState({
        media_id: media._id,
        visible: false,
        isTooltipBrandsVisible: false,
        isTooltipProductsVisible: false,
        isModalOfSelectionVisible: false,
        categories: [],
        isModalLoading: true,
        selectedBrands: media.brands,
        selectedProducts: media.products,
        isBefore: media.before || false,
        isAfter: media.after || false
      });
    }
  }
  updateBrandsAndProducts = async (media_id, brands = [], products = []) => {
    const responseData = await axios.put(process.env.REACT_APP_API + "/api/media/" + media_id, {
      $set: {
        brands,
        products
      }
    });
    if (!responseData || !responseData.data) return;

    const media = responseData.data;
    await this.setState({ selectedBrands: media.brands, selectedProducts: media.products });
  };

  updateMediaIsBefore = async tag => {
    let bodyContent;
    if (tag === "before" && !this.state.isBefore) {
      bodyContent = { before: true, after: false };
    } else if (tag === "after" && !this.state.isAfter) {
      bodyContent = { after: true, before: false };
    } else {
      bodyContent = tag === "before" ? { before: false } : { after: false };
    }
    const responseData = await axios.put(process.env.REACT_APP_API + "/api/media/" + this.state.media_id, {
      $set: bodyContent
    });
    if (!responseData || !responseData.data) return;
    const media = responseData.data;

    await this.setState({ isBefore: media.before, isAfter: media.after });
  };

  fetchBrandsAndProduct = async (visitId, locationTypeId, locationId) => {
    const token = await localStorage.getItem("access_token");
    const response = await axios.post(
      process.env.REACT_APP_API + "/api/visits/",
      {
        match: { _id: visitId },
        project: {
          survey: 1
        }
      },
      {
        headers: {
          Authorization: token
        }
      }
    );

    const responseData = response.data;
    const visit = Array.isArray(responseData) && responseData.length > 0 ? responseData[0] : { survey: [] };

    const locationType = visit.survey.find(locationType => locationType.locationTypeId === locationTypeId);
    if (!locationType || !Array.isArray(locationType.locations)) {
      await this.setState({ isModalLoading: false });
      return;
    }

    const location = locationType.locations.find(location => location.locationId === locationId);
    if (!location || !Array.isArray(location.categories)) {
      await this.setState({ isModalLoading: false });
      return;
    }
    await this.setState({ categories: location.categories || [], isModalLoading: false });
  };
  render() {
    let { media, checked, onCheck, zipcode, userRoleId } = this.props;

    media = media || {};
    const sector = media.sector || {};
    const mediaContent = media.media || {};
    const mediaContentResponse = mediaContent.response || {};
    const mediaContentResponseUrl = mediaContentResponse.url || "";
    const mediaUrlThumbnail = mediaContentResponse.urlResized || mediaContentResponse.url || "";
    const salepoint = media.salepoint || {};
    const salepointLabel = salepoint.label || "";
    const statement = media.statement || {};
    const endDateAsString = media.visit_end_date || "";
    const endDate = new Date(endDateAsString);
    const city1 = get(["salepoint", "adresse", "ville"], media);
    const city2 = get(["salepoint", "city"], media);
    const city = city1 || city2;

    const date =
      endDate.getUTCFullYear() +
      "/" +
      ("0" + (endDate.getUTCMonth() + 1)).slice(-2) +
      "/" +
      ("0" + endDate.getUTCDate()).slice(-2) +
      " " +
      ("0" + endDate.getUTCHours()).slice(-2) +
      ":" +
      ("0" + endDate.getUTCMinutes()).slice(-2) +
      ":" +
      ("0" + endDate.getUTCSeconds()).slice(-2);

    const statementLabel = statement.label || "";
    const sectorLabel = sector.sector_label || "";

    return (
      <Col span={5} className="p-phototheque-item">
        <div className="p-phototheque-item-container">
          <div className="p-phototheque-item-photo-container">
            <img
              onClick={() => {
                this.setState({
                  visible: true
                });
              }}
              className="p-phototheque-item-photo"
              src={AWS_URL + mediaUrlThumbnail}
            />
            <div className="p-phototheque-item-photo-check">
              <CheckboxButton checked={checked} media={media} onCheck={onCheck} />
            </div>
            <div className="p-phototheque-item-photo-star">
              <BestButton media={media} />
            </div>
            <Viewer
              visible={this.state.visible}
              drag={true}
              noClose={false}
              rotatable={true}
              scalable={true}
              downloadable={false}
              onMaskClick={() => {
                this.setState({ visible: false });
              }}
              onClose={() => {
                this.setState({ visible: false });
              }}
              customToolbar={toolbars => {
                return toolbars.concat([
                  {
                    key: "download_custom",
                    render: (
                      <li className="react-viewer-btn" data-key="download">
                        <i className="react-viewer-icon react-viewer-icon-download" />
                      </li>
                    ),
                    onClick: activeImage => {
                      forceDownload(activeImage.downloadUrl, activeImage.name + ".jpg");
                    }
                  }
                ]);
              }}
              images={[
                {
                  src: AWS_URL + mediaContentResponseUrl,
                  alt: "",
                  downloadUrl: MEDIA_DOWNLOAD_URL + media._id,
                  name: `${sectorLabel}, ${salepointLabel}, ${city} ${
                    Array.isArray(zipcode) && zipcode[0] ? `(${zipcode[0]})` : ""
                  } ${date.replace("/", "_")}`
                }
              ]}
            />
          </div>
        </div>

        <div className="p-phototheque-item-label">
          <div className="p-phototheque-item-label-text">
            <div className="p-phototheque-item-label-title">
              {sectorLabel}, {salepointLabel}, {city} {Array.isArray(zipcode) && zipcode[0] ? `(${zipcode[0]})` : ""}
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div className="p-phototheque-item-label-statement">{statementLabel}</div>
                <div className="p-phototheque-item-label-date">{date}</div>
              </div>
              {userRoleId !== roles.CLIENT && media.visit_id && (
                <Link
                  to={{
                    pathname: `/visit/preview/${media.visit_id}`
                  }}
                >
                  <Icon type="read" />
                </Link>
              )}
            </div>
          </div>

          <div
            className="p-phototheque-item-label-statement"
            style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", marginTop: 10 }}
          >
            <Tags
              userRoleId={userRoleId}
              isTooltipBrandsVisible={this.state.isTooltipBrandsVisible}
              selectedBrands={this.state.selectedBrands}
              updateBrandsAndProducts={this.updateBrandsAndProducts}
              media={media}
              brandOnMouseEnter={() => {
                this.setState({ isTooltipBrandsVisible: true });
              }}
              brandOnMouseLeave={() => {
                this.setState({ isTooltipBrandsVisible: false });
              }}
              openSelectionModal={() => {
                const locationType = media.locationType || {};
                const location = media.location || {};
                this.fetchBrandsAndProduct(media.visit_id, locationType.locationTypeId, location.locationId);
                if (userRoleId !== roles.CLIENT) this.setState({ isModalOfSelectionVisible: true });
              }}
              closeSelectionModal={() => {
                this.setState({ isModalOfSelectionVisible: false });
              }}
              isTooltipProductsVisible={this.state.isTooltipProductsVisible}
              selectedProducts={this.state.selectedProducts}
              categories={this.state.categories}
              productOnMouseEnter={() => this.setState({ isTooltipProductsVisible: true })}
              productOnMouseLeave={() => this.setState({ isTooltipProductsVisible: false })}
              isModalOfSelectionVisible={this.state.isModalOfSelectionVisible}
              isModalLoading={this.state.isModalLoading}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", alignItems: "center" }}>
            <div
              style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}
            >
              <CheckboxButton
                checked={this.state.isBefore}
                onCheck={() => this.updateMediaIsBefore("before")}
                userRoleId={userRoleId}
              />
              <span style={{ marginLeft: 5 }}>avant</span>
            </div>
            <div
              style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}
            >
              <CheckboxButton
                checked={this.state.isAfter}
                onCheck={() => this.updateMediaIsBefore("after")}
                userRoleId={userRoleId}
              />
              <span style={{ marginLeft: 5 }}>après</span>
            </div>
          </div>
        </div>
      </Col>
    );
  }
}

Photo.propTypes = {
  media: PropTypes.object,
  checked: PropTypes.bool
};

export default Photo;



// WEBPACK FOOTER //
// src/components/phototheque/Photo.js